// JOBE-0044.10: ProcedureValuePopover — tri-state for `procedure:` /
// `by-run:` predicates. Three radio buttons: any (no chip), specific
// URN (renders an inline scalar input), one-off (`procedure:none`).

import { useEffect, useRef, useState } from 'react';

const ANY = 'any';
const SPECIFIC = 'specific';
const ONE_OFF = 'oneoff';

export function ProcedureValuePopover({
  initialValues = [],
  onSubmit,
  onCancel,
}) {
  const initialMode = (() => {
    const v = initialValues[0];
    if (v === 'none') return ONE_OFF;
    if (v) return SPECIFIC;
    return ANY;
  })();
  const [mode, setMode] = useState(initialMode);
  const [urn, setUrn] = useState(() => {
    const v = initialValues[0];
    return v && v !== 'none' ? v : '';
  });
  const urnRef = useRef(null);

  useEffect(() => {
    if (mode === SPECIFIC) {
      urnRef.current?.focus();
    }
  }, [mode]);

  const onKeyDown = (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      if (onCancel) onCancel();
    }
  };

  const submit = () => {
    if (mode === ANY) {
      if (onCancel) onCancel();
      return;
    }
    if (mode === ONE_OFF) {
      if (onSubmit) onSubmit(['none']);
      return;
    }
    const trimmed = urn.trim();
    if (!trimmed) return;
    if (onSubmit) onSubmit([trimmed]);
  };

  return (
    <div
      className="library-composer-popover library-composer-procedure"
      role="dialog"
      aria-label="Pick procedure"
      onKeyDown={onKeyDown}
    >
      <div className="library-composer-popover-body">
        <fieldset className="library-composer-procedure-modes">
          <legend className="library-composer-procedure-legend">Procedure</legend>
          <label className="library-composer-procedure-mode">
            <input
              type="radio"
              name="procedure-mode"
              checked={mode === ANY}
              onChange={() => setMode(ANY)}
            />
            <span>Any procedure</span>
          </label>
          <label className="library-composer-procedure-mode">
            <input
              type="radio"
              name="procedure-mode"
              checked={mode === SPECIFIC}
              onChange={() => setMode(SPECIFIC)}
            />
            <span>Specific procedure URN</span>
          </label>
          {mode === SPECIFIC && (
            <input
              ref={urnRef}
              type="text"
              className="library-composer-scalar-input"
              placeholder="urn:jobe:procedure:…"
              value={urn}
              onChange={(e) => setUrn(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') { e.preventDefault(); submit(); }
              }}
              aria-label="Procedure URN"
            />
          )}
          <label className="library-composer-procedure-mode">
            <input
              type="radio"
              name="procedure-mode"
              checked={mode === ONE_OFF}
              onChange={() => setMode(ONE_OFF)}
            />
            <span>One-off (no procedure)</span>
          </label>
        </fieldset>
      </div>
      <div className="library-composer-popover-foot">
        <button
          type="button"
          className="library-composer-submit"
          onClick={submit}
          disabled={mode === SPECIFIC && !urn.trim()}
        >
          {mode === ANY ? 'Close' : 'Add chip'}
        </button>
      </div>
    </div>
  );
}
